/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import e from "../Viewpoint.js";
import t from "../core/Error.js";
import r from "../core/Logger.js";
import { urlToObject as o } from "../core/urlUtils.js";
import { geographicToWebMercator as i } from "../geometry/support/webMercatorUtils.js";
import a from "../portal/Portal.js";
import { project as n } from "../rest/geometryService/project.js";
import s from "../rest/support/ProjectParameters.js";
function l(e, t) {
  return t.resourceInfo ? p(t, t.resourceInfo, {
    origin: e.origin
  }) : t.portalItem?.id ? c(e, t, t.portalItem) : Promise.resolve();
}
function p(e, t, r) {
  const o = {
    context: {
      ...r,
      layerContainerType: "operational-layers"
    }
  };
  return e.portalItem && (o.context.portal = e.portalItem.portal || a.getDefault()), import("../layers/support/layersCreator.js").then(({
    populateOperationalLayers: r
  }) => {
    const i = [],
      a = t.operationalLayers;
    a?.length && i.push(r(e.layers, a, o));
    const n = {
        ...o,
        context: {
          ...o.context,
          layerContainerType: "tables"
        },
        defaultLayerType: "ArcGISFeatureLayer"
      },
      s = t.tables;
    return s?.length && i.push(r(e.tables, s, n)), Promise.allSettled(i).then(() => {});
  });
}
async function c(e, i, n) {
  if (await n.load().catch(r => {
    throw new t(`${e.name}:load-portal-item`, "Failed to load portal item", {
      error: r
    });
  }), n.type !== e.itemType) throw new t(`${e.name}:invalid-portal-item`, `Invalid portal item type '${n.type}', expected '${e.itemType}'`, {
    type: n.type
  });
  const s = await n.fetchData();
  i.resourceInfo = s;
  const l = {
    origin: e.origin,
    url: o(n.itemUrl),
    portal: n.portal || a.getDefault(),
    portalItem: n,
    readResourcePaths: []
  };
  await m(e, i, s, l), i.resourceReferences = {
    portalItem: n,
    paths: l.readResourcePaths
  };
  const p = await f(i.initialViewProperties, n, r.getLogger(i));
  if (p) {
    const t = i.initialViewProperties?.clone() ?? e.createInitialViewProperties();
    t.viewpoint = p, i.initialViewProperties = t;
  }
}
function m(e, t, r, o) {
  const i = u(e, r);
  return t.read(i, o), p(t, i, o);
}
function u(e, t) {
  const r = e.parseVersion(t.version || "", e.name);
  return e.currentVersion.validate(r), t.version = `${r.major}.${r.minor}`, t;
}
async function f(t, r, o) {
  const i = t?.viewpoint?.targetGeometry;
  if (i) return null;
  const a = await y(t, r, o);
  if (!a) return null;
  return new e({
    targetGeometry: a
  });
}
async function y(e, t, r) {
  const o = e?.spatialReference,
    a = t?.extent;
  if (!o || !a) return null;
  if (o.isWGS84) return a.clone();
  if (o.isWebMercator) return i(a);
  const {
    getGeometryServiceURL: l
  } = await import("../portal/support/geometryServiceUtils.js");
  try {
    const e = await l(t),
      r = new s();
    r.geometries = [a], r.outSpatialReference = o;
    return (await n(e, r))[0];
  } catch (p) {
    r.error("Error projecting item's extent:", p);
  }
  return null;
}
export { l as loadFromSource };